import { RouteObject } from 'react-router-dom';
import { Main } from '../../containers/Dashboard/dashboard';
import Login from '../../pages/Login/Login';
import { AddPurchaseOrder } from '../../containers/purchases/orders/add_order';
import { CreatePurchaseBill } from '../../containers/purchases/bills/create_bill';
import { CompanyInfo } from '../../containers/Company/company_detail';
import PermissionPage from '../../components/no-permission/page';
import { lazy } from 'react';
import { SpreedSheet } from '../../containers/Spreedsheet/spreedsheet';
import Dashboard from '../../pages/Dashboard/Dashboard';
import Orders from '../../containers/Orders/Orders'
import  Bills from '../../containers/Bills/Bills'
import Clients from '../../containers/Clients/Clients'
import   Employees from '../../containers/Employees/Employees' 
import Materials from '../../containers/Materials/Materials';
import  Order from '../../containers/Order/EditOrder';

import  PaymentVouchers from '../../containers/PaymentVouchers/PaymentVouchers'
import  Pricing from '../../containers/Pricing/Pricing'

import  ReceiptVouchers from '../../containers/ReceiptVouchers/ReceiptVouchers'
import  Roles  from '../../containers/Roles/Roles'
import  Services from '../../containers/Services/Services'
import  Suppliers from '../../containers/Suppliers/Suppliers'
import  Users from '../../containers/Users/Users'
//const  Dashboard = lazy  (()=>import ('../../pages/Dashboard/Dashboard'));

import CreateBills from '../../containers/Bills/create_bills'

import  AddOrder from '../../containers/Order/AddOrder'

import  PurchaseOrders from  '../../containers/purchases/orders/orders'
import  PurchaseBills from '../../containers/purchases/bills/bills'

import  Reports from '../../containers/Report-control/control'

import Company  from '../../containers/Company/company'
import ExpensesType from '../../containers/ExpensesType/ExpensesType';

export const routesObject = (authenticated: boolean): RouteObject[] => {
  return [
    authenticated
      ? {
          path: '/',
          element: <Dashboard />,
          children: [
            { path: '/', index: true, element: <Main /> },

            {
              path: 'materials',
              element: (
                <PermissionPage permission_key="View Glass">
                  <Materials />
                </PermissionPage>
              ),
            },
            {
              path: 'services',
              element: (
                <PermissionPage permission_key="View Glass Work">
                  <Services />
                </PermissionPage>
              ),
            },
            {
              path: 'pricing',
              element: (
                <PermissionPage permission_key="Show Pricing">
                  <Pricing />
                </PermissionPage>
              ),
            },
            {
              path: 'expenses_type',
              element: (
                <PermissionPage permission_key="Show Expense Type">
                  <ExpensesType />
                </PermissionPage>
              ),
            },
            {
              path: 'roles',
              element: (
                <PermissionPage permission_key="View Role">
                  <Roles />
                </PermissionPage>
              ),
            },
            {
              path: 'users',
              element: (
                <PermissionPage permission_key="View User">
                  <Users />
                </PermissionPage>
              ),
            },
            {
              path: 'employees',
              element: (
                <PermissionPage permission_key="View Employee">
                  <Employees />
                </PermissionPage>
              ),
            },
            {
              path: 'clients',
              element: (
                <PermissionPage permission_key="View Client">
                  <Clients />
                </PermissionPage>
              ),
            },
            {
              path: 'suppliers',
              element: (
                <PermissionPage permission_key="View Supplier">
                  <Suppliers />
                </PermissionPage>
              ),
            },

            { path: 'orders/clientid/:id', element: <Orders /> },
            { path: 'orders/:orderid', element:
            <PermissionPage permission_key="Show Order">
             <Order /> 
             </PermissionPage>
             },
            { path: 'orders/add_order', element: 
            <PermissionPage permission_key="Add Order">
            <AddOrder /> 
            </PermissionPage>
            },
            {
              path: 'orders',
              element: (
                <PermissionPage permission_key="View Order">
                  <Orders />
                </PermissionPage>
              ),
            },

            { path: 'bills/:bill_id', element:
            <PermissionPage permission_key="Show Bill">

             <CreateBills /> 
             </PermissionPage>
             },
            {
              path: 'bills',
              element: (
                <PermissionPage permission_key="View Bill">
                  <Bills />
                </PermissionPage>
              ),
            },

            { path: 'createbill/orders/:order_id', element: <CreateBills /> },
          
            {
              path: 'receipt-vouchers',
              element: (
                <PermissionPage permission_key="View Receipt Voucher">
                  <ReceiptVouchers />
                </PermissionPage>
              ),
            },
            {
              path: 'payment-vouchers',
              element: (
                <PermissionPage permission_key="View Pay Voucher">
                  <PaymentVouchers />
                </PermissionPage>
              ),
            },
            {
              path: 'purchase-bills',
              element: (
                <PermissionPage permission_key="View Purchase Bill">
                  <PurchaseBills />
                </PermissionPage>
              ),
            },
            {
              path: 'create-purchase-bill/:order_id',
              element: 
              <PermissionPage permission_key="Add Purchase Bill">
              <CreatePurchaseBill />
              </PermissionPage>
              ,
            },

            {
              path: 'purchase-bills/:bill_id',
              
              element:<PermissionPage permission_key="Show Purchase Bill">
               <CreatePurchaseBill />
               </PermissionPage>
               ,
            },
            {
              path: 'purchase-orders',
              element: (
                <PermissionPage permission_key="View Purchase Order">
                  <PurchaseOrders />
                </PermissionPage>
              ),
            },
            { path: 'add-purchase-order', element:
            <PermissionPage permission_key="Add Purchase Order">
             <AddPurchaseOrder /> 
             </PermissionPage>
             },
            {
              path: 'add-purchase-order/:order_id',
              element:
              <PermissionPage permission_key="Show Purchase Order">
               <AddPurchaseOrder />
               </PermissionPage>
               ,
            },
            {
              path: 'spreedsheet/:path/:date_from/:date_to/:id',
              element: 
              <PermissionPage permission_key='Show Report'>

                <SpreedSheet />
              </PermissionPage>
            },
            {
              path: 'spreedsheet/:path/:date_from/:date_to/',
              element: 
              <PermissionPage permission_key='Show Report'>

                <SpreedSheet />
              </PermissionPage>
              ,
            },
            {
              path: 'reports',
              element: (
                <PermissionPage permission_key="View Report">
                  <Reports />
                </PermissionPage>
              ),
            },
            {
              path: 'company-info',
              element: (
                <PermissionPage permission_key="View Company">
                  <Company />
                </PermissionPage>
              ),
            },
            { path: 'company-info/:company_id', element: 
            <PermissionPage permission_key="Show Company">
            <CompanyInfo /> 
            </PermissionPage>
            },
          ],
        }
      : {
          path: '/login',
          element: <Login />,
        },
  ];
};
